<template>
  <div v-show="isHover" class="ln-hover-icon" :class="{ 'is-show': isShow, iconcross: iscross }" ref="hoverIcon">
    <div class="hover-icon-wrap" :class="{ dot: !isShow }" @click="showBtns">
      <van-button round type="info" icon="user-o" class="hover-icon"> </van-button>
    </div>

    <div class="hover-btns" :class="{ 'is-show': isShow }" :style="btnsStyle">
      <span class="hover-btn" @click="toggleAccount">{{ isLogined ? '切换账号' : '登录' }}</span>
      <span class="hover-btn dot" @click="changeComponent('UserAccount')">账号</span>
    </div>
    <!-- <div class="hover-icon" :class="{ hot: isHot }" @click="showBtns"></div> -->
    <!-- <div class="hover-btns"></div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import draggable, { isMobile } from '@/draggable';
import mixServer from '../server/mixServer';
import server from '@/server';
import { sendMsg } from '@/server';
import store from '../store';
import { notificationPostmessager } from '../features/notificationPostmessager';

export default {
  name: 'ln-hover-icon',
  data() {
    return {
      isShow: false,
      iscross: false
    };
  },
  computed: {
    ...mapState(['user', 'componentParams', 'isHover']),
    isLogined() {
      return this.user.account;
    },
    btnsStyle() {
      const width = !this.isShow ? '36px' : this.isLogined ? '145px' : '115px';
      return { width };
    },
    disabled() {
      return this.componentParams && this.componentParams.is_allow_online == 0;
    }
  },
  created() {
    if (window.innerWidth > window.innerHeight) {
      this.iscross = true;
    } else {
      this.iscross = false;
    }
  },
  mounted() {
    this.setDrag();
    // 解决cp出的包在支付后clentheight为0导致top为负数的情况
    var det = window.getComputedStyle(this.$refs.hoverIcon).top.replace('px', '');
    if (Number(det) < 0) {
      this.$refs.hoverIcon.style.top = '60px';
    }
    window.onresize = () => {
      if (Number(det) < 0) {
        this.$refs.hoverIcon.style.top = '60px';
      }
    };
  },
  methods: {
    setDrag() {
      const el = this.$refs.hoverIcon;
      const { clientWidth, clientHeight } = document.documentElement;
      // console.log(isMobile)
      // if (isMobile) {
      // 移动端的拖动
      draggable(el, {
        drag: e => {
          const touch = e.changedTouches[0];
          // 定位到元素中间
          // console.log('a1111')
          const EL_MIDDLE = el.clientHeight / 2;
          let top = touch.clientY - EL_MIDDLE;
          const minTop = 0;
          const maxTop = clientHeight - el.clientHeight;
          const resultTop = Math.min(Math.max(minTop, top), maxTop);
          if (clientHeight <= 0) {
            if (top <= 0) top = 0;
            el.style.top = `${top}px`;
          } else {
            el.style.top = `${resultTop}px`;
          }
        }
      });
      // } else {
      //   // PC端的拖动(有空需解决：1、拖动太快导致鼠标脱离el，需要绑定到document，但是iframe无法触发document的问题 2、移动后，需要禁止触发子按钮的点击事件)
      //   draggable(el, {
      //     drag: e => {
      //       const { clientX, clientY } = e;
      //       // 定位到元素中间
      //       const EL_MIDDLE = el.clientHeight / 2;
      //       const top = clientY - EL_MIDDLE;
      //       const minTop = 0;
      //       const maxTop = clientHeight - el.clientHeight;
      //       const resultTop = Math.min(Math.max(minTop, top), maxTop);

      //       const EL_MIDDLE_WIDTH = el.clientWidth / 2;
      //       const right = clientX - EL_MIDDLE_WIDTH;
      //       const minRight = 0;
      //       const maxRight = clientWidth - el.clientWidth;
      //       const resultRight = Math.min(Math.max(minRight, right), maxRight);

      //       el.style.right = 'initial';
      //       el.style.top = `${resultTop}px`;
      //       el.style.left = `${resultRight}px`;
      //     }
      //   });
      // }
    },
    showBtns() {
      // 如果禁止不给点击
      // if (this.disabled) return;
      this.isShow = !this.isShow;
    },
    changeComponent(componentName) {
      this.$store.commit('SHOW', componentName);
      this.$store.commit('SET_CLICKACC', true);
      store.commit('SET_SHOWBIND', store.state.initBind);
      this.isShow = false;
      if (componentName == 'Login' || componentName == 'PhoneLogin') {
        clearInterval(server.timer);
        if (
          mixServer.game_link.indexOf('huanyuantech.com') > -1 ||
          mixServer.game_link.indexOf('h5game.jiuyaowangluo.com') > -1
        ) {
          console.log({ account: mixServer.mixAccount, uid: mixServer.ouid, token: mixServer.mixToken });
          this.$store.commit('SET_CHANGECLICK', true);
          sendMsg('LOGOUT_SUCCESS', {});
        }
      }
      const needRefreshGame = [
        'https://sdk.sh9130.com',
        'https://h5.uu89.com',
        'luckystar001',
        'h5game.jiuyaowangluo.com',
        'isp2-dev.hhycdk.com',
        'https://isp2.hhycdk.com',
        'h5game.rastargame.com',
        'shdl-web-cdn.leniu.com',
        'shdl-web-test-cdn.leniu.com',
        'leteng5.cn',
        's3-api.dgcgame.com',
        'xtgame.top',
        'f2kp'
      ];
      const isRefresh = needRefreshGame.some(v => mixServer.game_link.indexOf(v) > -1);
      if (isRefresh && (componentName == 'Login' || componentName == 'PhoneLogin')) {
        const gameFrame = document.querySelector('#gameFrame');
        gameFrame.src = `${mixServer.game_link}?v=${new Date().getTime()}`;
        this.$store.commit('SET_CHANGECLICK', true);
      } else {
        // 切换账号的登录回调
        if (componentName != 'UserAccount') {
          this.$store.commit('SET_CHANGECLICK', true);
          // sendMsg('LOGIN_SUCCESS', {account: 'cg_acc'});
          // this.$store.commit('CLOSE');
        }
      }
      if (
        (mixServer.game_link.indexOf('isp2.hhycdk.com') > -1 || mixServer.game_link.indexOf('s3-api.dgcgame.com') > -1 || mixServer.game_link.indexOf('shdl-web-cdn.leniu.com') > -1 || mixServer.game_link.indexOf('shdl-web-test-cdn.leniu.com') > -1 || mixServer.game_link.indexOf('f2kp') > -1) &&
        (componentName == 'Login' || componentName == 'PhoneLogin')
      ) {
        this.$store.commit('CLOSE');
      }
      // 根据卧龙三国吊起时机问题，不弹登录弹窗
      if (
        mixServer.game_link.indexOf('h5game.jiuyaowangluo.com') > -1 &&
        (componentName == 'Login' || componentName == 'PhoneLogin')
      ) {
        this.$store.commit('CLOSE');
      }

      // if (mixServer.game_link.indexOf('https://sdk.sh9130.com') > -1 && componentName == 'Login') {
      //   const gameFrame = document.querySelector('#gameFrame');
      //   gameFrame.src = `${mixServer.game_link}?v=${new Date().getTime()}`;
      // }
      // if (mixServer.game_link.indexOf('https://h5.uu89.com') > -1 && componentName == 'Login') {
      //   const gameFrame = document.querySelector('#gameFrame');
      //   gameFrame.src = `${mixServer.game_link}&v=${new Date().getTime()}`;
      // }
      // if (mixServer.game_link.indexOf('https://cls-wc02.huanyuantech.com') > -1 && componentName == 'Login') {
      //   const gameFrame = document.querySelector('#gameFrame');
      //   gameFrame.src = `${mixServer.game_link}&v=${new Date().getTime()}`;
      // }
    },
    toggleAccount() {
      this.changeComponent('PhoneLogin');
      // 切换账号时：【通知中心】断开长连接
      notificationPostmessager.emit({
        action: 'NOTIFICATION_DISCONNECT',
        data: {}
      });
    }
  }
};
</script>
<style lang="scss">
/* @import ('url') */
.ln-hover-icon {
  position: fixed;
  z-index: 999999;
  right: 0;
  top: 60px;
  opacity: 0.6;
  transition: opacity 0.3s;
  &.is-show {
    opacity: 1;
  }

  .hover-icon-wrap {
    position: relative;
    z-index: 1;
    &.dot::after {
      top: 5px;
      right: 3px;
    }
    .hover-icon {
      padding: 0;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      line-height: 36px;
    }
  }

  .hover-btns {
    position: absolute;
    overflow: hidden;
    z-index: 0;
    height: 36px;
    display: flex;
    align-items: center;
    top: 0;
    right: 0;
    background: #e4e7ed;
    border-radius: 18px;
    font-size: 13px;
    padding-left: 0;
    width: 36px;
    transition: width 0.3s;
    &.is-show {
      padding-left: 10px;
    }
    .hover-btn {
      white-space: nowrap;
      padding: 0 5px;
    }
  }
}
.dot {
  position: relative;
}
.dot::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  // width: 6px;
  min-width: 0;
  // height: 6px;
  // background-color: #ee0a24;
  border-radius: 100%;
  // border: 1px solid #fff;
}
</style>
